import React, { useEffect, useState } from "react";
import { CircularProgressCustom } from "./common-components/CircularProgressCustom";
import { useQuery } from "@apollo/react-hooks";
import { GET_TOTAL_PRODUCTS, GET_PRODUCTS } from "./../../services/graphql-query";
import { apiUrl } from "./../../services/constants";
import { Pagination } from 'react-bootstrap';
import { BsFilter, BsDownload, BsSearch } from 'react-icons/bs';
import SelectFilter from "./ResourceSearch/SelectFilter";
import '../../css/app.css';

export default function Resources() {

    const [isTotal, setTotal] = useState(20);
    const [isProducts, setProducts] = useState([]);

    const [selectCategory, setSelectCategory] = useState([]);
    const [selectCollection, setSelectCollection] = useState([]);
    const [selectLumen, setSelectLumen] = useState([]);
    const [selectTemperature, setSelectTemperature] = useState([]);
    const [selectWattage, setSelectWattage] = useState([]);
    const [selectDistribution, setSelectDistribution] = useState([]);
    const [selectCertification, setSelectCertification] = useState([]);

    const [isCategory, setCategory] = useState([]);
    const [isCollection, setCollection] = useState([]);
    const [isLumen, setLumen] = useState([]);
    const [isTemperature, setTemperature] = useState([]);
    const [isWattage, setWattage] = useState([]);
    const [isDistribution, setDistribution] = useState([]);
    const [isCertification, setCertification] = useState([]);

    const [totalRow, setTotalRow] = useState(1);
    const [active, setActive] = useState(-1);
    const [limitRow, setLimitRow] = useState(6);
    const [limitPagination, setLimitPagination] = useState(4);
    const [activeItem, setActiveItem] = useState(1);
    const [items, setItems] = useState([]);

    const total_products = useQuery(GET_TOTAL_PRODUCTS);

    useEffect(() => {
        if (total_products.data) {
            setTotal(total_products.data.products.meta.pagination.total);
        }
    })

    const { loading, error, data } = useQuery(GET_PRODUCTS, { variables: { totalProducts: isTotal }, onCompleted: (res) => setProducts(res.products.data) });

    useEffect(() => {

        const totalRow = (Math.ceil(isProducts.length / limitRow))

        setTotalRow(totalRow);

        if (activeItem + 1 > limitPagination) {
            createPagination(activeItem + 1 - limitPagination + 2, totalRow);
        } else {
            createPagination(1, totalRow);
        }

    }, [isProducts, activeItem])

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectCategory.length) {
                data.products.data.map((item) => {
                    selectCategory.map((category) => {
                        if (item?.attributes?.collection.data?.attributes?.category?.data?.attributes?.name === category) {
                            products.push(item);
                        }
                    })
                })
            } else {
                data.products.data.map((item) => {
                    products.push(item);
                })
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })
        setProducts(myset);

        // setProducts(products);

    }, [selectCategory]);

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectCollection.length) {
                data.products.data.map((item) => {
                    selectCollection.map((collection) => {
                        if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                            products.push(item);
                        }
                    })
                })
            } else {
                if (selectCategory.length) {
                    data.products.data.map((item) => {
                        selectCategory.map((category) => {
                            if (item?.attributes?.collection?.data?.attributes?.category?.data?.attributes?.name === category) {
                                products.push(item);
                            }
                        })
                    })
                } else {
                    data.products.data.map((item) => {
                        products.push(item);
                    })
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);

        // setProducts(products);

    }, [selectCollection]);

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectLumen.length) {
                if (selectWattage.length) {
                    data.products.data.map((item) => {
                        selectWattage.map((wattage) => {
                            if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                products.push(item)
                            }
                        })
                    })
                }
                if (selectDistribution.length) {
                    data.products.data.map((item) => {
                        selectDistribution.map((distribution) => {
                            item?.attributes?.distributions?.data?.map((distribution_data) => {
                                if (distribution_data?.attributes?.Name === distribution) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                if (selectCertification.length) {
                    data.products.data.map((item) => {
                        selectCertification.map((certification) => {
                            item?.attributes?.certifications?.data?.map((certification_data) => {
                                if (certification_data?.attributes?.Name === certification) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                data.products.data.map((item) => {
                    selectLumen.map((lumen) => {
                        item?.attributes?.lumen?.data?.map((lumen_data) => {
                            if (lumen_data?.attributes?.Lumen === lumen) {
                                products.push(item)
                            }
                        })
                    })
                })
            } else {
                if (selectCollection.length) {
                    data.products.data.map((item) => {
                        selectCollection.map((collection) => {
                            if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                                products.push(item)
                            }
                        })
                    })
                } else {
                    if (selectCategory.length) {
                        data.products.data.map((item) => {
                            selectCategory.map((category) => {
                                if (item?.attributes?.collection?.data?.attributes?.category?.data?.attributes?.name === category) {
                                    products.push(item);
                                }
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            products.push(item);
                        })
                    }
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);

    }, [selectLumen]);

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectTemperature.length) {
                if (selectWattage.length) {
                    data.products.data.map((item) => {
                        selectWattage.map((wattage) => {
                            if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                products.push(item)
                            }
                        })
                    })
                }
                if (selectDistribution.length) {
                    data.products.data.map((item) => {
                        selectDistribution.map((distribution) => {
                            item?.attributes?.distributions?.data?.map((distribution_data) => {
                                if (distribution_data?.attributes?.Name === distribution) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                if (selectCertification.length) {
                    data.products.data.map((item) => {
                        selectCertification.map((certification) => {
                            item?.attributes?.certifications?.data?.map((certification_data) => {
                                if (certification_data?.attributes?.Name === certification) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                if (selectLumen.length) {
                    data.products.data.map((item) => {
                        selectLumen.map((lumen) => {
                            item?.attributes?.lumen?.data?.map((lumen_data) => {
                                if (lumen_data?.attributes?.Lumen === lumen) {
                                    selectTemperature.map((temperature) => {
                                        item?.attributes?.lumen?.data?.map((lumen_data1) => {
                                            if (lumen_data1?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                }
                            })
                        })
                    })
                } else {
                    data.products.data.map((item) => {
                        selectTemperature.map((temperature) => {
                            item?.attributes?.lumen?.data?.map((lumen_data) => {
                                if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
            } else {
                if (selectLumen.length) {
                    if (selectWattage.length) {
                        data.products.data.map((item) => {
                            selectWattage.map((wattage) => {
                                if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                    products.push(item)
                                }
                            })
                        })
                    }
                    if (selectDistribution.length) {
                        data.products.data.map((item) => {
                            selectDistribution.map((distribution) => {
                                item?.attributes?.distributions?.data?.map((distribution_data) => {
                                    if (distribution_data?.attributes?.Name === distribution) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    if (selectCertification.length) {
                        data.products.data.map((item) => {
                            selectCertification.map((certification) => {
                                item?.attributes?.certifications?.data?.map((certification_data) => {
                                    if (certification_data?.attributes?.Name === certification) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    data.products.data.map((item) => {
                        selectLumen.map((lumen) => {
                            item?.attributes?.lumen?.data?.map((lumen_data) => {
                                if (lumen_data?.attributes?.Lumen === lumen) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                } else {
                    if (selectWattage.length) {
                        if (selectDistribution.length) {
                            data.products.data.map((item) => {
                                selectDistribution.map((distribution) => {
                                    item?.attributes?.distributions?.data?.map((distribution_data) => {
                                        if (distribution_data?.attributes?.Name === distribution) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        if (selectCertification.length) {
                            data.products.data.map((item) => {
                                selectCertification.map((certification) => {
                                    item?.attributes?.certifications?.data?.map((certification_data) => {
                                        if (certification_data?.attributes?.Name === certification) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        data.products.data.map((item) => {
                            selectWattage.map((wattage) => {
                                if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                    products.push(item)
                                }
                            })
                        })
                    } else {
                        if (selectDistribution.length) {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            }
                            data.products.data.map((item) => {
                                selectDistribution.map((distribution) => {
                                    item?.attributes?.distributions?.data?.map((distribution_data) => {
                                        if (distribution_data?.attributes?.Name === distribution) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        } else {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            } else {
                                if (selectCollection.length) {
                                    data.products.data.map((item) => {
                                        selectCollection.map((collection) => {
                                            if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                } else {
                                    if (selectCategory.length) {
                                        data.products.data.map((item) => {
                                            selectCategory.map((category) => {
                                                if (item?.attributes?.collection.data?.attributes?.category?.data?.attributes?.name === category) {
                                                    products.push(item);
                                                }
                                            })
                                        })
                                    } else {
                                        data.products.data.map((item) => {
                                            products.push(item);
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);

    }, [selectTemperature]);

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectWattage.length) {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                }
                if (selectDistribution.length) {
                    data.products.data.map((item) => {
                        selectDistribution.map((distribution) => {
                            item?.attributes?.distributions?.data?.map((distribution_data) => {
                                if (distribution_data?.attributes?.Name === distribution) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                if (selectCertification.length) {
                    data.products.data.map((item) => {
                        selectCertification.map((certification) => {
                            item?.attributes?.certifications?.data?.map((certification_data) => {
                                if (certification_data?.attributes?.Name === certification) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                data.products.data.map((item) => {
                    selectWattage.map((wattage) => {
                        if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                            products.push(item)
                        }
                    })
                })
            } else {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    if (selectDistribution.length) {
                        data.products.data.map((item) => {
                            selectDistribution.map((distribution) => {
                                item?.attributes?.distributions?.data?.map((distribution_data) => {
                                    if (distribution_data?.attributes?.Name === distribution) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    if (selectCertification.length) {
                        data.products.data.map((item) => {
                            selectCertification.map((certification) => {
                                item?.attributes?.certifications?.data?.map((certification_data) => {
                                    if (certification_data?.attributes?.Name === certification) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        if (selectDistribution.length) {
                            data.products.data.map((item) => {
                                selectDistribution.map((distribution) => {
                                    item?.attributes?.distributions?.data?.map((distribution_data) => {
                                        if (distribution_data?.attributes?.Name === distribution) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        if (selectCertification.length) {
                            data.products.data.map((item) => {
                                selectCertification.map((certification) => {
                                    item?.attributes?.certifications?.data?.map((certification_data) => {
                                        if (certification_data?.attributes?.Name === certification) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        if (selectDistribution.length) {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            }
                            data.products.data.map((item) => {
                                selectDistribution.map((distribution) => {
                                    item?.attributes?.distributions?.data?.map((distribution_data) => {
                                        if (distribution_data?.attributes?.Name === distribution) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        } else {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            } else {
                                if (selectCollection.length) {
                                    data.products.data.map((item) => {
                                        selectCollection.map((collection) => {
                                            if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                } else {
                                    if (selectCategory.length) {
                                        data.products.data.map((item) => {
                                            selectCategory.map((category) => {
                                                if (item?.attributes?.collection.data?.attributes?.category?.data?.attributes?.name === category) {
                                                    products.push(item);
                                                }
                                            })
                                        })
                                    } else {
                                        data.products.data.map((item) => {
                                            products.push(item);
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);

        // setProducts(products);

    }, [selectWattage]);

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectDistribution.length) {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                }
                if (selectWattage.length) {
                    data.products.data.map((item) => {
                        selectWattage.map((wattage) => {
                            if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                products.push(item)
                            }
                        })
                    })
                }
                if (selectCertification.length) {
                    data.products.data.map((item) => {
                        selectCertification.map((certification) => {
                            item?.attributes?.certifications?.data?.map((certification_data) => {
                                if (certification_data?.attributes?.Name === certification) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                data.products.data.map((item) => {
                    selectDistribution.map((distribution) => {
                        item?.attributes?.distributions?.data?.map((distribution_data) => {
                            if (distribution_data?.attributes?.Name === distribution) {
                                products.push(item)
                            }
                        })
                    })
                })
            } else {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    if (selectWattage.length) {
                        data.products.data.map((item) => {
                            selectWattage.map((wattage) => {
                                if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                    products.push(item)
                                }
                            })
                        })
                    }
                    if (selectCertification.length) {
                        data.products.data.map((item) => {
                            selectCertification.map((certification) => {
                                item?.attributes?.certifications?.data?.map((certification_data) => {
                                    if (certification_data?.attributes?.Name === certification) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        if (selectWattage.length) {
                            data.products.data.map((item) => {
                                selectWattage.map((wattage) => {
                                    if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                        products.push(item)
                                    }
                                })
                            })
                        }
                        if (selectCertification.length) {
                            data.products.data.map((item) => {
                                selectCertification.map((certification) => {
                                    item?.attributes?.certifications?.data?.map((certification_data) => {
                                        if (certification_data?.attributes?.Name === certification) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        if (selectWattage.length) {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            }
                            data.products.data.map((item) => {
                                selectWattage.map((wattage) => {
                                    if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                        products.push(item)
                                    }
                                })
                            })
                        } else {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            } else {
                                if (selectCollection.length) {
                                    data.products.data.map((item) => {
                                        selectCollection.map((collection) => {
                                            if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                } else {
                                    if (selectCategory.length) {
                                        data.products.data.map((item) => {
                                            selectCategory.map((category) => {
                                                if (item?.attributes?.collection.data?.attributes?.category?.data?.attributes?.name === category) {
                                                    products.push(item);
                                                }
                                            })
                                        })
                                    } else {
                                        data.products.data.map((item) => {
                                            products.push(item);
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);


        // setProducts(products)

    }, [selectDistribution])

    useEffect(() => {

        const products = [];
        const uniqueIds = [];

        if (data) {
            if (selectCertification.length) {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                }
                if (selectDistribution.length) {
                    data.products.data.map((item) => {
                        selectDistribution.map((distribution) => {
                            item?.attributes?.distributions?.data?.map((distribution_data) => {
                                if (distribution_data?.attributes?.Name === distribution) {
                                    products.push(item)
                                }
                            })
                        })
                    })
                }
                if (selectWattage.length) {
                    data.products.data.map((item) => {
                        selectWattage.map((wattage) => {
                            if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                products.push(item)
                            }
                        })
                    })
                }
                data.products.data.map((item) => {
                    selectCertification.map((certification) => {
                        item?.attributes?.certifications?.data?.map((certificaion_data) => {
                            if (certificaion_data?.attributes?.Name === certification) {
                                products.push(item)
                            }
                        })
                    })
                })
            } else {
                if (selectTemperature.length) {
                    if (selectLumen.length) {
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        data.products.data.map((item) => {
                            selectTemperature.map((temperature) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.temperature?.data?.attributes?.value_temperature === temperature) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                    if (selectWattage.length) {
                        data.products.data.map((item) => {
                            selectWattage.map((wattage) => {
                                if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                    products.push(item)
                                }
                            })
                        })
                    }
                    if (selectDistribution.length) {
                        data.products.data.map((item) => {
                            selectDistribution.map((distribution) => {
                                item?.attributes?.distributions?.data?.map((distribution_data) => {
                                    if (distribution_data?.attributes?.Name === distribution) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    }
                } else {
                    if (selectLumen.length) {
                        if (selectWattage.length) {
                            data.products.data.map((item) => {
                                selectWattage.map((wattage) => {
                                    if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                        products.push(item)
                                    }
                                })
                            })
                        }
                        if (selectDistribution.length) {
                            data.products.data.map((item) => {
                                selectDistribution.map((distribution) => {
                                    item?.attributes?.distributions?.data?.map((distribution_data) => {
                                        if (distribution_data?.attributes?.Name === distribution) {
                                            products.push(item)
                                        }
                                    })
                                })
                            })
                        }
                        data.products.data.map((item) => {
                            selectLumen.map((lumen) => {
                                item?.attributes?.lumen?.data?.map((lumen_data) => {
                                    if (lumen_data?.attributes?.Lumen === lumen) {
                                        products.push(item)
                                    }
                                })
                            })
                        })
                    } else {
                        if (selectWattage.length) {
                            if (selectCertification.length) {
                                data.products.data.map((item) => {
                                    selectCertification.map((certification) => {
                                        item?.attributes?.certifications?.data?.map((certification_data) => {
                                            if (certification_data?.attributes?.Name === certification) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            }
                            data.products.data.map((item) => {
                                selectWattage.map((wattage) => {
                                    if (item?.attributes?.wattages?.data[0]?.attributes?.Watt === wattage) {
                                        products.push(item)
                                    }
                                })
                            })
                        } else {
                            if (selectDistribution.length) {
                                data.products.data.map((item) => {
                                    selectDistribution.map((distribution) => {
                                        item?.attributes?.distributions?.data?.map((distribution_data) => {
                                            if (distribution_data?.attributes?.Name === distribution) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                })
                            } else {
                                if (selectCollection.length) {
                                    data.products.data.map((item) => {
                                        selectCollection.map((collection) => {
                                            if (item?.attributes?.collection?.data?.attributes?.name === collection) {
                                                products.push(item)
                                            }
                                        })
                                    })
                                } else {
                                    if (selectCategory.length) {
                                        data.products.data.map((item) => {
                                            selectCategory.map((category) => {
                                                if (item?.attributes?.collection.data?.attributes?.category?.data?.attributes?.name === category) {
                                                    products.push(item);
                                                }
                                            })
                                        })
                                    } else {
                                        data.products.data.map((item) => {
                                            products.push(item);
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let myset = products.filter((element) => {
            const isDuplicate = uniqueIds.includes(element?.id);

            if (!isDuplicate) {
                uniqueIds.push(element?.id);

                return true;
            }

            return false;
        })

        setProducts(myset);


    }, [selectCertification])

    const filter_data = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

    const createPagination = (start, totalRow) => {
        const paginations = [];
        let first = start
        let limit = start + limitPagination;
        if (start + limitPagination > totalRow) {
            if (totalRow >= 4) {
                limit = totalRow + 1;
                first = totalRow - 3;
            } else {
                first = start;
                limit = totalRow + 1;
            }
        }
        for (let number = first; number < limit; number++) {
            paginations.push(
                <Pagination.Item onClick={() => selectItem(number)} key={number} active={activeItem === number ? true : false}>
                    {number}
                </Pagination.Item>,
            );
        }
        setItems(paginations)
    }

    const handleFilter = (index) => {
        if (active === index) {
            index = -1;
        }
        setActive(index)
    }

    const selectItem = (item) => {
        setActiveItem(item);
    }

    const firstItem = () => {
        setActiveItem(1);
    }

    const lastItem = () => {
        setActiveItem(totalRow);
    }

    const previousItem = () => {
        if (activeItem !== 1) {
            setActiveItem(activeItem - 1);
        }
    }

    const nextItem = () => {
        if (activeItem < totalRow) {
            setActiveItem(activeItem + 1)
        }
    }

    if (loading) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    return (
        <div className="container resource">
            <div className="resource-header">
                <h1>Documents & Resources</h1>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et</p>
            </div>
            <div className="resource-filter mt-5">
                <div className="filter-header">
                    <div className="filter-title"><BsFilter className="mr-2" />FILTERS:</div>
                    <div className="box">
                        <div className="container-1">
                            <span className="icon"><BsSearch /></span>
                            <input type="search" id="search" placeholder="Search..." />
                        </div>
                    </div>
                </div>
                <div className="filter-btns mt-3">
                    <div>BY PRODUCT NAME</div>
                    <ul className="filter-btn">
                        {
                            filter_data.map((filter, index) =>
                                <li key={index} className={active === index ? 'filter-btn-active' : 'filter-btn-inactive'} onClick={() => handleFilter(index)}>{filter}</li>
                            )
                        }
                    </ul>
                </div>
                <div className="filter-select mt-3">
                    <SelectFilter selectCategory={selectCategory} setSelectCategory={setSelectCategory} selectCollection={selectCollection} setSelectCollection={setSelectCollection} selectLumen={selectLumen} setSelectLumen={setSelectLumen} selectTemperature={selectTemperature} setSelectTemperature={setSelectTemperature} selectWattage={selectWattage} setSelectWattage={setSelectWattage} selectDistribution={selectDistribution} setSelectDistribution={setSelectDistribution} selectCertification={selectCertification} setSelectCertification={setSelectCertification} isCategory={isCategory} setCategory={setCategory} isCollection={isCollection} setCollection={setCollection} isLumen={isLumen} setLumen={setLumen} isTemperature={isTemperature} setTemperature={setTemperature} isWattage={isWattage} setWattage={setWattage} isDistribution={isDistribution} setDistribution={setDistribution} isCertification={isCertification} setCertification={setCertification} />
                </div>
            </div>
            <div className="resource-product mt-5">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col" width="40%">Product</th>
                            <th scope="col" width="30%">Description</th>
                            <th scope="col" width="30%">Downloads</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isProducts && isProducts.map((item, key) => key < activeItem * limitRow && key >= (activeItem - 1) * limitRow ?
                            (<tr key={key}>
                                <td className="product-image">
                                    <div className="d-flex flex-row align-items-center">
                                        <img src={apiUrl + item?.attributes?.image?.data?.attributes?.url} alt={item?.attributes?.title} style={{ width: "120px", height: "120px" }} />
                                        <div className="ml-5">
                                            <h5>{item?.attributes?.collection?.data?.attributes?.name}</h5>
                                            <span>{item?.attributes?.title}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="description" col="5">
                                    <div className="mt-3 mb-3">
                                        <div><span style={{ fontWeight: "bold", marginRight: "5px" }}>Wattage:</span><span>{item?.attributes?.wattages?.data[0]?.attributes?.Watt}W</span></div>
                                        <div className="mt-2 d-flex"><span style={{ fontWeight: "bold", marginRight: "5px" }}>Lumen/CCT:</span><div className="d-flex flex-column">{item?.attributes?.lumen?.data?.map((item, index) => <span key={index}>{item?.attributes?.Lumen}/{item?.attributes?.temperature?.data?.attributes?.value_temperature}</span>)}</div></div>
                                    </div>
                                </td>
                                <td className="pdf-download align-middle">
                                    <div>
                                        <a href={apiUrl + item?.attributes?.spec_pdf?.data[0]?.attributes?.url} target="_blank" className="d-flex" download><BsDownload className="mr-2" />{item?.attributes?.spec_pdf.data[0]?.attributes?.name}</a>
                                    </div>
                                </td>
                            </tr>) : null
                        )}
                    </tbody>
                </table>
                <div className="table-pagination">
                    <div>
                        Showing {limitRow} - {isProducts.length} items
                    </div>
                    <Pagination>
                        <Pagination.First onClick={firstItem} />
                        <Pagination.Prev onClick={previousItem} />
                        {items}
                        <Pagination.Next onClick={nextItem} />
                        <Pagination.Last onClick={lastItem} />
                    </Pagination>
                </div>
            </div>
        </div >
    );
}
